/**
 * Representative fluid densities for the pressure and buoyancy calculators.
 *
 * Values are rounded reference values at about 20 °C and 1 atm (the CRC Handbook of
 * Chemistry and Physics and NIST give water as 998.2071 kg/m³ at 20 °C; mercury's
 * 13 546 kg/m³ is its 20 °C density, not the 13 595.1 kg/m³ that *defines* the mmHg).
 * Seawater is the usual textbook mean of 1025 kg/m³, and air is the International
 * Standard Atmosphere sea-level density, 1.225 kg/m³. Real densities shift with
 * temperature, salinity and purity — at the third digit for the liquids here.
 */

export type FluidId =
  | "fresh-water"
  | "seawater"
  | "mercury"
  | "ethanol"
  | "glycerol"
  | "air";

export interface Fluid {
  id: FluidId;
  /** Density, kg/m³. */
  density: number;
}

export const FLUIDS: readonly Fluid[] = [
  { id: "fresh-water", density: 998.2 },
  { id: "seawater", density: 1025 },
  { id: "mercury", density: 13_546 },
  { id: "ethanol", density: 789 },
  { id: "glycerol", density: 1261 },
  { id: "air", density: 1.225 },
];

export function findFluid(id: string): Fluid | null {
  return FLUIDS.find((fluid) => fluid.id === id) ?? null;
}
